// @ts-nocheck
import {
  VictoryAccessibleGroup,
  VictoryAxis,
  VictoryArea,
  VictoryChart,
  VictoryGroup,
  VictoryLabel,
  VictoryLegend,
  VictoryLine,
  VictoryScatter,
  VictoryTheme,
  VictoryTooltip
} from 'victory'
import { colorArray } from 'utils'
import { HistoricalStreamFlowType, ToolTipLabelType } from '../../interfaces'
import { useState, useEffect, useId } from 'react'
import DownloadCSV from '../../../shared/DownloadCSV'

const HistoricalStreamFlow = ({ data, width }: HistoricalStreamFlowType) => {
  // labels for legend
  const [labels, setLabels] = useState(null)

  // bar data
  const [avgData, setAvgData] = useState(null)

  // sets up data for legend labels
  useEffect(() => {
    if (data && data.average && !labels) {
      if (data.average.length > 0) {
        const labelData = data.average.map(({ x1, x2, y }, i) => {
          return {
            name: `${x1} - ${x2} (${y}GL)`,
            symbol: { type: 'square', fill: colorArray[i], fillOpacity: 0.4 }
          }
        })
        // @ts-ignore
        setLabels([
          ...labelData,
          {
            name: 'Annual Total',
            symbol: { fill: colorArray[colorArray.length - 1] }
          }
        ])
      }
    }
  }, [labels, data, setLabels])

  useEffect(() => {
    if (data && data.average && !avgData) {
      if (data.average.length > 0) {
        const newData = data.average.map((avg) => [
          { x: avg.x1, y: avg.y },
          { x: avg.x2, y: avg.y }
        ])
        // @ts-ignore
        setAvgData(newData)
      }
    }
  }, [data, avgData, setAvgData])
  const id = useId()
  return (
    <>
      <VictoryChart
        desc='chart plotting historical streamflow'
        theme={VictoryTheme.material}
        domainPadding={{ x: [10, 40] }}
        padding={{
          left: 90,
          right: 50,
          top: 40,
          bottom: width > 600 ? 190 : 250
        }}
        width={width}
        height={width > 600 ? 600 : 680}
        style={{
          parent: {
            width,
            height: width > 600 ? 600 : 680
          }
        }}
      >
        {
          // @ts-ignore
          (avgData ?? []).map((x, i) => (
            <VictoryArea
              animate
              // @ts-ignore
              key={x[0]?.x}
              data={x}
              style={{
                data: {
                  fill: colorArray[i],
                  fillOpacity: 0.2,
                  strokeWidth: 0
                }
              }}
            />
          ))
        }
        {data?.yearlyData && (
          <VictoryGroup animate
          groupComponent={<VictoryAccessibleGroup aria-label="plot of historical streamflow" />}
          >
            <VictoryLine
              data={data.yearlyData}
              style={{
                data: {
                  stroke: colorArray[colorArray.length - 1],
                  strokeWidth: 2,
                  strokeLinecap: 'round'
                }
              }}
            />

            <VictoryScatter
              data={data.yearlyData}
              size={4}
              style={{
                data: {
                  fill: colorArray[colorArray.length - 1]
                }
              }}
              labels={(l) => l}
              // @ts-ignore
              minBubbleSize={8}
              labelComponent={
                <VictoryTooltip
                  cornerRadius={4}
                  // @ts-ignore
                  minBubbleSize={8}
                  orientation="bottom"
                  pointerOrientation="bottom"
                  flyoutWidth={150}
                  flyoutHeight={50}
                  pointerWidth={150}
                  constrainToVisibleArea
                  flyoutStyle={{
                    fill: '#ffffff',
                    stroke: colorArray[colorArray.length - 1]
                  }}
                  labelComponent={
                    <ToolTipLabel
                      // @ts-ignore
                      year={(d) => d.x}
                      color={colorArray[colorArray.length - 1]}
                      unit="GL"
                    />
                  }
                />
              }
            />
          </VictoryGroup>
        )}
        {/* x axis */}
        <VictoryAxis
          orientation="bottom"
          width={width}
          style={{
            axis: { stroke: '#C7C7C7', strokeWidth: 1, strokeLength: 2 },
            axisLabel: {
              fontSize: 16,
              fontFamily: 'Arial'
            },
            grid: { stroke: 'transparent', strokeWidth: 0, strokeLength: 0 },
            ticks: { stroke: 'transparent' }
          }}
          fixLabelOverlap
          tickCount={7}
          tickFormat={(x) => `${x}`}
          tickLabelComponent={
            <VictoryLabel
              id={(i) => `x:${id}:${i.index}`}
              dx={10}
              angle={90}
              style={{
                fontSize: 16,
                fontFamily: 'Arial',
                fontWeight: 'bold',
                fill: '#6E6E6E'
              }}
            />
          }
        />
        {/* y axis */}
        <VictoryAxis
          dependentAxis
          tickFormat={(x) => `${x} GL`}
          tickCount={6}
          style={{
            axis: { stroke: 'transparent' },
            axisLabel: {
              fontSize: 16,
              fontFamily: 'Arial'
            },
            // @ts-ignore
            grid: { stroke: '#C7C7C7', strokeWidth: 1, strokeLength: 2 },
            ticks: { stroke: 'transparent' },
            tickLabels: {
              fontSize: 16,
              fill: '#6E6E6E',
              fontFamily: 'Arial'
            }
          }}
          tickLabelComponent={
            <VictoryLabel
              id={(i) => `y:${id}:${i.index}`}
              style={{
                fontSize: 16,
                fill: '#6E6E6E',
                fontFamily: 'Arial',
                fontWeight: 'bold'
              }}
            />
          }
        />
        {
          // @ts-ignore
          labels && labels.length && (
            // @ts-ignore
            <VictoryLegend
              x={
                width > 740
                  ? width / 2 - 345
                  : width > 490
                    ? width / 2 - 245
                    : width / 2 - 120
              }
              y={width > 600 ? 480 : 500}
              width={width}
              orientation="horizontal"
              itemsPerRow={width > 740 ? 3 : width > 490 ? 2 : 1}
              gutter={80}
              rowGutter={{ top: 0, bottom: 10 }}
              style={{
                border: { stroke: 'transparent' }
              }}
              data={labels}
              labelComponent={
                <VictoryLabel
                  id={(i) => `ledg:${id}:${i.index}`}
                  style={{
                    fontSize: 16,
                    fill: '#6E6E6E',
                    fontFamily: 'Arial',
                    fontWeight: 'bold'
                  }}
                />
              }
            />
          )
        }
      </VictoryChart>
      {data?.yearlyData && (
        <div className="w-full flex justify-center sm:justify-end mt-8 pb-16">
          <DownloadCSV
            jsonData={data?.yearlyData}
            filename="historical-streamflow.csv"
            linkname="Download historical streamflow data CSV"
          />
        </div>
      )}
    </>
  )
}

const ToolTipLabel = ({
  x,
  y,
  datum,
  color,
  style,
  textAnchor
}: ToolTipLabelType) => {
  return (
    <text style={style} x={x} y={y} textAnchor={textAnchor}>
      <tspan style={{ fontSize: 10 }} dx={-50} dy={-10}>
        {datum && datum.x}
      </tspan>
      <tspan style={{ fill: color }} y={y ?? 0 + 70} dx={25}>
        ●
      </tspan>
      <tspan>Annual Total:</tspan>
      <tspan style={{ fontWeight: 'bold' }}>{datum && datum.y}GL</tspan>
    </text>
  )
}

export default HistoricalStreamFlow
